module.exports = __webpack_public_path__ + "assets/img/syj.5b04c5af.png";